import FlexBox from "lib/components/common/flex-box";
import SimpleButton from "lib/components/common/simple-button";
import SimpleCard from "lib/components/common/simple-card";
import SimpleModal from "lib/components/common/simple-modal";
import SimpleTextbox from "lib/components/common/simple-textbox";
import { BUSINESS_CATEGORIES } from "lib/constants";
import { FC, useEffect, useState } from "react";
import { PiPencilBold } from "react-icons/pi";

interface PractitionerBusinessProfileCardProps {
  isLoading?: boolean;
  practitionerDetails?: PractitionerDetails;
  isEditable?: boolean;
  //   isOrganization?: boolean;
  //   website?: string;
  //   onChangeOrganization?: (value: boolean) => void;
  //   onWebsiteChange?: (value: string) => void;
  onChange?: (values: PractitionerDetails) => void;
  isPractitionerUrl?: boolean;
}

const PractitionerBusinessProfileCard: FC<
  PractitionerBusinessProfileCardProps
> = ({
  isEditable = true,
  isLoading,
  practitionerDetails,
  onChange,
  //   isOrganization,
  //   onChangeOrganization,
  //   website,
  //   onWebsiteChange,
  isPractitionerUrl = false,
}) => {
  const [isShowModal, setIsShowModal] = useState<boolean>(false);

  const [businessNameContent, setBusinessNameContent] = useState<string>(
    practitionerDetails?.businessName
  );
  const [websiteContent, setWebsiteContent] = useState<string>(
    practitionerDetails?.websiteLink
  );

  // const isOrganization =
  //   practitionerDetails?.businessCategory?.localeCompare(
  //     BUSINESS_CATEGORIES.ORGANISATION
  //   ) === 0;

  const isOrganization = practitionerDetails?.businessCategory.toLowerCase() === BUSINESS_CATEGORIES.ORGANISATION.toLowerCase()
  useEffect(() => {
    if (practitionerDetails?.websiteLink) {
      setWebsiteContent(practitionerDetails?.websiteLink);
    }
    if (practitionerDetails?.businessName) {
      setBusinessNameContent(practitionerDetails?.businessName);
    }
  }, [practitionerDetails]);

  return (
    <>
      <SimpleCard
        title="Business Profile"
        isTitleNoBg
        isLoading={isLoading}
        action={
          isOrganization &&
          isEditable && (
            <SimpleButton
              suffixIcon={<PiPencilBold />}
              onClick={() => setIsShowModal(true)}
            >
              Edit
            </SimpleButton>
          )
        }
      >
        <FlexBox
          direction="column"
          className="gap-4 mt-3"
          justifyContent="start"
          alignItems="start"
        >
          {/* { isPractitionerUrl &&
            <SimpleSwitch
            isDisabled={!isEditable}
            name="isOrganization"
            label={`${isOrganization ? "Disable" : "Enable"} Business Profile`}
            value={isOrganization}
            onChange={(e) =>
              onChange?.({
                ...practitionerDetails,
                businessCategory: e.target.checked
                  ? BUSINESS_CATEGORIES.ORGANISATION
                  : BUSINESS_CATEGORIES.INDIVIDUAL,
              })
            }
            yesIcon={<PiHospitalBold />}
            noIcon={<PiUserBold />}
          />} */}

          {isOrganization && (
            <>
              <h6>
                Business Name: <strong>{businessNameContent}</strong>
              </h6>
              <p 
               className="text-break"
              >
                Website:{" "}
                {websiteContent ? (
                  <a href={websiteContent} target="_blank" rel="noreferrer">
                    {websiteContent}
                  </a>
                ) : (
                  <span>
                    <u>No website provided</u>
                  </span>
                )}
              </p>
            </>
          )}
        </FlexBox>
      </SimpleCard>
      <SimpleModal
        size="sm"
        title="Edit Website"
        open={isShowModal}
        close={() => setIsShowModal(false)}
        footer={
          <SimpleButton
            onClick={() => {
              setIsShowModal(false);
              onChange?.({
                ...practitionerDetails,
                websiteLink: websiteContent,
                businessName: businessNameContent,
              });
            }}
          >
            Update
          </SimpleButton>
        }
      >
        <SimpleTextbox
          label="Business Name"
          value={businessNameContent}
          onChange={(e) => setBusinessNameContent(e.target.value)}
        />
        <SimpleTextbox
          label="Website"
          value={websiteContent}
          onChange={(e) => setWebsiteContent(e.target.value)}
        />
      </SimpleModal>
    </>
  );
};
export default PractitionerBusinessProfileCard;
